/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import stylesheet
 */
import "../scss/contact.scss";

/**
 * Import modules / classes
 */
import ContactMap from "./modules/page-contact/ContactMap";
import ContactForm from "./modules/page-contact/ContactForm";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myContactForm = new ContactForm();
    const myContactMap = new ContactMap();
});
